import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    input,
    model,
    untracked
} from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { SiPillsInputComponent } from '@siemens/element-ng/pills-input';
import { SubjectArea } from '@tran-monorepo/interfaces/applications';
import { subjectAreasAtLeastOneRequired } from '../../../utils';
import { SubjectAreaSelectorComponent } from '../../form';
import { ApplicationDetailDashboardBoxComponent } from '../application-detail-dashboard-box/application-detail-dashboard-box.component';
import { ApplicationSubjectAreasForm } from '../application-detail.form';

@Component({
    selector: 'tran-application-additional-subject-areas',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ApplicationDetailDashboardBoxComponent,
        SubjectAreaSelectorComponent,
        SiFormItemComponent,
        SiPillsInputComponent,
        TranslateModule
    ],
    templateUrl: './application-additional-subject-areas.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationAdditionalSubjectAreasComponent {
    public readonly heading = input<string>(
        'components.application-detail-dashboard.application-additional-subject-areas.heading'
    );
    public readonly selectedSubjectAreas = input<SubjectArea[]>([]);
    public readonly allPredefinedSubjectAreas = input<SubjectArea[]>([]);
    public readonly additionalSubjectAreas = input<string[]>([]);
    public readonly readonly = input(false, { transform: booleanAttribute });
    public readonly isLoading = model<boolean>(false);
    public readonly form = input<ApplicationSubjectAreasForm | null>(null);

    protected readonly localForm: ApplicationSubjectAreasForm = new FormGroup({
        subjectAreas: new FormControl<SubjectArea[]>([], { nonNullable: true }),
        additionalSubjectAreas: new FormArray<FormControl<string>>([])
    }) as ApplicationSubjectAreasForm;

    protected readonly subjectAreasDisplayControl = new FormControl<string[]>([], { nonNullable: true });

    protected readonly activeForm = computed(() => this.form() ?? this.localForm);
    protected readonly isSubjectAreaRequired = computed(() =>
        this.activeForm().hasValidator(subjectAreasAtLeastOneRequired)
    );
    protected readonly subjectAreasDisplayNames = computed(() =>
        this.selectedSubjectAreas()
            .map(subjectArea => subjectArea.name)
            .concat(this.additionalSubjectAreas())
    );

    constructor() {
        effect(() => {
            const subjectAreas = this.selectedSubjectAreas();
            const additionalSubjectAreas = this.additionalSubjectAreas();

            if (subjectAreas?.length || additionalSubjectAreas?.length) {
                untracked(() => {
                    this.activeForm().patchValue({
                        subjectAreas,
                        additionalSubjectAreas
                    });
                });
            }
        });

        effect(() => {
            this.subjectAreasDisplayControl.setValue(this.subjectAreasDisplayNames(), { emitEvent: false });
        });
    }
}
